import { Button, Icon, Intent, Popover, Position } from "@blueprintjs/core"
import { useEffect, useRef, useState } from "react"
import { LoaderMinimal } from "src/libs/useful/Loading"
import { __ } from "src/libs/utilities"
import useClickOutside from "src/modules/pe-fest-module/widgets/hooks/useClickOutside"
import { MAP_FILTER, MAP_TYPE_ICON } from "../../data/interfaces"
import { IToposStore, useToposStore } from "../../data/store"

/* Protopia Ecosystem component */
export interface IMapTypeButtonProps {
   mapType: string
   markers: any[] 
   isLoading: boolean
   onFilter: ( ddd : MAP_FILTER) => void
   onMarkerClick: ( evt:any, coords: number[], data: any ) => void
}
const MapTypeButton = (props: IMapTypeButtonProps): JSX.Element => {
    const ref = useRef(null)
    const btnRef = useRef(null)
    const [width, setWidth] = useState<number>(0)
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const mapMode: MAP_FILTER = useToposStore((state: IToposStore) => state.mapMode)
    useClickOutside( btnRef, () => setIsOpen(false) )
    
    useEffect(() => {
        if(!!ref.current) { 
            const w = (ref.current as any)!.getBoundingClientRect().width 
            if(!!w) {
                console.log(w )
                setWidth(w + 20 )
            }
            else {
                setWidth(2)
            }
        }
    }, [ props.isLoading, props.mapType ])
    
    const getMarkersCount = ( _mapMode: MAP_FILTER ) : JSX.Element => { 
        return _mapMode === mapMode 
            ?
            props.isLoading
                ?
                <span className=" opacity_75 "><LoaderMinimal /></span>
                :
                <span className=" opacity_75 d-flex align-items-center ">
                    {props.markers.length} 
                    { !!props.markers.length && <Icon icon="caret-down" className="ml-2"/> }
                </span>
            :
            <></>
    }
 
    const onBtnClick = (data: any) => {
        props.onMarkerClick( null, [], data )
        setIsOpen(false)
    }

    const ddd = props.mapType.toString()
    return <>
         <Button 
            onClick={() => props.onFilter( ddd as MAP_FILTER )} 
            className={ mapMode === ddd ? " untouchble " : "" }
            intent={ mapMode === ddd ? Intent.DANGER : Intent.NONE }
            
        >
            <span className="d-flex align-items-center">
                <div
                    style={{
                        backgroundImage: `url(${(MAP_TYPE_ICON[ ddd as keyof typeof MAP_TYPE_ICON ])})`,
                        width: 12, 
                        height: 12,
                        filter: mapMode === ddd ? "invert(100%)" : undefined, 
                    }}
                    className="thumbnail icon-contrast-fill"
                />  
                <span className="small d-flex ml-2">
                    {__( "MAP_FILTER." + ddd )}
                </span>
            </span>            
        </Button> 
        {
            !props.markers.length 
                ?
                <Button
                    intent={ Intent.DANGER } 
                    className="p-0 w_0 overflow-x-hidden transition-300"
                    style={{ width, minWidth: width, maxWidth: width }} 
                >
                    <span className="small d-flex" ref={ref}>
                        {getMarkersCount( ddd as MAP_FILTER )}
                    </span>
                </Button>
                :
                <Popover
                    position={Position.BOTTOM_LEFT}
                    isOpen={ isOpen }
                    content={
                        <div className="p-0 maxw-300 max_h_300 overflow-y-auto" >
                            {
                                props.markers.map(m => {
                                    return <Button
                                        key={m.data.id}
                                        fill minimal
                                        alignText="left"
                                        onClick={() => onBtnClick(  m.data )}
                                    >
                                        <span className="small">{  m.hintContent }</span>
                                    </Button>
                                })
                            }
                        </div>
                    }
                >
                    <Button
                        intent={ Intent.DANGER } 
                        className="p-0 w_0 overflow-x-hidden transition-300"
                        style={{ width, minWidth: width, maxWidth: width }} 
                        onClick={ () => setIsOpen(true) }
                        ref={ btnRef }
                    >
                        <span className="small d-flex" ref={ref}>
                            {getMarkersCount( ddd as MAP_FILTER )}
                        </span>
                    </Button>
                </Popover>
        } 
    </>
}
export default MapTypeButton